export default __webpack_public_path__ + "static/media/logotipo.a785d39b.svg";